// Only Civil can be created (useNuevaCausaForm fixes competencia to cod 3) and
// verified by the scraper. Add an option here only when that changes.
export const COMPETENCE_FILTER_OPTIONS = [{ value: 'Civil', label: 'Civil' }];
